import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import cn from 'classnames'
import Addon from '../../../models/Addon'
import AddonItem from '../../addon-item'
import Button from '../../Button'
import { addonUnitPrice, currencyFormatter } from '../../../utils/functions'
import classes from './senior-addons.module.sass'
import PackageBuilderHelper from '../../package-builder-helper'
import useQueryString from '../../../hooks/use-query-string'
import useSeniorImages from '../package-builder/use-senior-images'
import useOption from '../package-builder/use-option'
import usePackage from '../package-builder/use-package'
import useBackgroundsFromPackage from '../package-builder/use-backgrounds-from-package'
import Typography from '../../Typography'
import { CustomerContext } from '../../../contexts/CustomerContext'
import { OrderPackage } from '../../../models'
import { routes } from '../../../routes'
import useLocalStorage from '../../../hooks/useLocalStorage';

const buildingDenyList = [
  'Name & Year on Wallets',
]

// TODO: check for already added addons
const SeniorAddons = () => {
  const [isOrderingAhead] = useLocalStorage('orderingAhead')

  const history = useHistory()
  const { customer, setCustomer } = useContext(CustomerContext)
  const {
    favs: favorites,
    opt: optionId,
    package: packageId,
    op: orderPackageId,
    isSenior = true,
  } = useQueryString()
  const backgrounds = useBackgroundsFromPackage(packageId)
  const seniorPackage = usePackage(packageId)
  const studentImages = useSeniorImages(favorites, isSenior)
  const option = useOption(optionId)
  const [addons, setAddons] = useState()
  const [selected, setSelected] = useState([])
  const [step, setStep] = useState(0)
  const [orderPackage, setOrderPackage] = useState(null)

  const onContinue = () => {
    if (selected.length === 0) {
      if (isSenior) {
        history.push(routes.seniorPortraitReview(orderPackage.id))
      } else {
        history.push(routes.multiPoseReview(orderPackage.id))
      }
    } else {
      setStep(1)
    }
  }

  const addItem = (newId) => setSelected((prev) => [...prev, newId])
  const removeItem = (newId) => setSelected((prev) => prev.filter((id) => id !== newId))

  const createAddonSheets = async (sheets) => {
    orderPackage.addonSheets = sheets

    await orderPackage.save({ with: 'addonSheets' })

    setCustomer({ ...customer, currentOrderPackage: orderPackage })
    if (isSenior) {
      history.push(routes.seniorPortraitReview(orderPackage.id))
    } else {
      history.push(routes.multiPoseReview(orderPackage.id))
    }
  }

  useEffect(() => {
    if (!orderPackageId) return

    OrderPackage
      .find(orderPackageId)
      .then((res) => setOrderPackage(res.data))
  }, [orderPackageId])

  useEffect(() => {
    // visibleToCustomers keeps drafts and withdrawn add-ons out of the picker.
    const params = isSenior
      ? { isSenior, visibleToCustomers: true }
      : { isElementary: true, visibleToCustomers: true }

    Addon
      .where(params)
      .all()
      .then((res) => setAddons(res.data))
  }, [])

  useEffect(() => {
    if (!orderPackage) return
    if (orderPackage.cartId === parseInt(customer.cart.id, 10)) return

    history.push(routes.home())
  }, [orderPackage])

  if (!(addons && orderPackage)) return null

  return (
    <div className={cn(classes.container, (step !== 1) ? classes.padded : '')}>
      {step === 0 && (
        <>
          <div className={classes.navButtons}>
            <Button fullWidth variant="submit" onClick={onContinue}>Continue</Button>
          </div>
          <div className={classes.addonsContainer}>
            {addons.map((addon) => {
              const included = selected.includes(addon.id)
              const symbol = included ? '-' : '+'
              const onClick = included ? () => removeItem(addon.id) : () => addItem(addon.id)

              return (
                <AddonItem
                  active={included}
                  key={addon.id}
                  text={`${symbol} ${addon.name}`}
                  price={currencyFormatter(addonUnitPrice(addon, orderPackage))}
                  onClick={onClick}
                />
              )
            })}
          </div>
        </>
      )}
      {step === 1 && (
        <PackageBuilderHelper
          checkForeground={!isOrderingAhead}
          addons
          backgrounds={backgrounds}
          selectedOption={option}
          selectedPackage={seniorPackage}
          placeholder={isOrderingAhead ? seniorPackage.placeholderImage() : selected}
          studentImages={studentImages}
          checkMaxPoses={false}
          maxPoses={10_000}
          forwardText="Finish"
          onComplete={(sheets) => {
            setStep(2)
            createAddonSheets(sheets)
          }}
          sheetList={addons
            .filter((addon) => (
              selected.includes(addon.id) && !buildingDenyList.includes(addon.name)
            )).map((addon) => ({ name: addon.name, count: addon.imageCount, addonId: addon.id, classname: addon.cssName }))}
        />
      )}
      {step === 2 && (
        <Typography align="center" weight="bold">Adding your addons to your package...</Typography>
      )}
    </div>
  )
}

export default SeniorAddons
